"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reviver = exports.replacer = void 0;
const many_js_1 = require("@liftedinit/many-js");
const convert_1 = require("./convert");
const mapDataType = "Map";
const anonymousBackwardCompatibleDataType = 'r';
const webauthnBackwardCompatibleDataType = 'c';
function replacer(_, value) {
    if (value instanceof Map) {
        return {
            dataType: mapDataType,
            value: Array.from(value.entries()),
        };
    }
    return value;
}
exports.replacer = replacer;
function reviver(_, value) {
    if (typeof value === "object" && value !== null) {
        if (value.dataType === mapDataType) {
            return new Map(value.value);
        }
        else if (value instanceof Object &&
            value.type === "Buffer" &&
            value.data) {
            return Buffer.from(value.data);
        }
        else {
            switch (value.dataType) {
                case anonymousBackwardCompatibleDataType:
                case many_js_1.AnonymousIdentity.dataType:
                    return new many_js_1.AnonymousIdentity();
                case webauthnBackwardCompatibleDataType:
                case many_js_1.WebAuthnIdentity.dataType:
                    return new many_js_1.WebAuthnIdentity(value.cosePublicKey, (0, convert_1.base64ToArrayBuffer)(value.rawId));
            }
        }
    }
    console.warn("Unknown JSON found, not deserializing:", value);
    return value;
}
exports.reviver = reviver;
